import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isIOSDevice } from '../utils/deviceDetection';

const LandingHeader: React.FC = () => {
  const navigate = useNavigate();
  const isIOS = isIOSDevice();

  const handleLogin = () => {
    navigate('/auth/login');
  };

  const handleSignUp = () => {
    navigate('/onboarding');
  };

  return (
    <header 
      className="fixed w-full bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100"
      style={{ 
        top: 0,
        paddingTop: isIOS ? 'env(safe-area-inset-top, 0px)' : '0'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div 
            className="flex items-center gap-2 sm:gap-3 cursor-pointer" 
            onClick={() => navigate('/')}
          >
            <span className="text-xl sm:text-2xl font-bold text-[#4A6651]" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              DinnerBrain
            </span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              onClick={() => navigate('/blog')}
              className="hidden min-h-[44px] px-3 py-2 text-sm font-medium text-[#4A6651] transition-colors hover:text-[#3d5444] sm:inline-flex sm:items-center"
            >
              Blog
            </button>
            <button
              onClick={handleLogin}
              className="px-3 sm:px-5 py-2 text-sm sm:text-base text-[#4A6651] font-medium border border-[#4A6651] rounded-lg hover:bg-[#4A6651] hover:text-white transition-colors"
            >
              Log In
            </button>
            <button
              onClick={handleSignUp}
              className="px-3 sm:px-5 py-2 text-sm sm:text-base bg-[#4A6651] text-white font-medium rounded-lg hover:bg-[#3d5444] transition-colors"
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;